var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12 d-flex flex-column justify-content-center align-items-center pl-0"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg",
      "checked": _vm.llaStatus,
      "value": true,
      "unchecked-value": false
    },
    on: {
      "change": _vm.changeHandler
    }
  }, [_c('span', {
    staticClass: "llaText",
    style: {
      color: _vm.textColor
    }
  }, [_vm._v(" " + _vm._s(_vm.llaStatement) + " "), _c('a', {
    style: {
      color: _vm.llaColor
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.displayModalWindow
    }
  }, [_vm._v("Limited Liability Agreement (LLA).")])])]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.llaStatus
    }
  }, [_vm._v(" This Limited Liability Agreement (LLA) MUST be accepted in order to continue ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLLAAgreementStatus,
      expression: "showLLAAgreementStatus"
    }],
    staticClass: "modal-window-overlay"
  }, [_c('div', {
    staticClass: "modal-window-display"
  }, [_c('div', {
    staticClass: "modal-window-body lla-modal-window-body"
  }, [_c('div', {
    staticClass: "modal-window-close-container"
  }, [_c('button', {
    staticClass: "modal-window-close-container-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.showLLAAgreementStatus = false;
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  })])]), _c('div', {
    staticClass: "container-fluid p-0"
  }, [_c('div', {
    staticClass: "lla-modal-container"
  }, [_c('div', {
    staticClass: "row m-0 h-100"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-12 col-lg-9 col-xl-9 pl-3 pl-lg-0 pl-xl-0 d-flex flex-column justify-content-center align-items-start lla-content-gap",
    staticStyle: {
      "min-height": "600px"
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "h-auto w-100 d-flex justify-content-center align-items-center"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "lg",
      "checked": _vm.llaStatus,
      "value": true,
      "unchecked-value": false
    },
    on: {
      "change": _vm.changeHandler
    }
  }, [_c('span', {
    staticClass: "text-agreement"
  }, [_vm._v("I agree to these new terms and conditions")])])], 1)])])])])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12 col-lg-3 col-xl-3 d-flex flex-column justify-content-start align-items-center lla-content-gap mt-4",
    staticStyle: {
      "height": "fit-content"
    }
  }, [_c('div', {
    staticClass: "w-100 modal-window-title-text d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "lla-modal-title-text text-center text-lg-left text-xl-left"
  }, [_vm._v(" Limited Liability Agreement ")])]), _c('div', {
    staticClass: "w-100 modal-window-title-text d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "lla-modal-title-text text-center text-lg-left text-xl-left"
  }, [_vm._v(" Terms & Conditions ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-window-text-content h-100 lla-modal-text-content",
    staticStyle: {
      "min-height": "550px"
    }
  }, [_c('iframe', {
    staticClass: "lla-content-iframe",
    attrs: {
      "id": "iframe-content",
      "src": "https://projectspectrumlearning.io/legal/calla.pdf#toolbar=0&navpanes=0&scrollbar=0",
      "frameborder": "0"
    }
  })]);

}]

export { render, staticRenderFns }